import { Injectable } from "@angular/core";
import { MedicalPrescriptionValidity } from "src/app/ui/models/domains/pbm/Benefit/medical-prescription-validity";

@Injectable()
export class MedicalPrescriptionValidityParser {
  parse(payload: any): Array<MedicalPrescriptionValidity> {
    const medicalPrescriptionValidityList: Array<MedicalPrescriptionValidity> = [];
    payload.forEach((data) => {
      const medicalPrescriptionValidity = new MedicalPrescriptionValidity();
      medicalPrescriptionValidity.setKey(data.Key);
      medicalPrescriptionValidity.setUseType(data.UseType);
      medicalPrescriptionValidity.setDaysValidity(data.DaysValidity);
      medicalPrescriptionValidityList.push(medicalPrescriptionValidity);
    });
    return medicalPrescriptionValidityList;
  }
}
